export default __webpack_public_path__ + "static/media/pass.cabfa12c.png";